import React from "react"
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material"
import i18n from "@/i18n"

const STYLES = {
  confirmText: "text-gray-700",
} as const

export type RemoveSectionDialogProps = {
  open: boolean
  sectionTitle: string
  onConfirm: () => void
  onClose: () => void
}

export const RemoveSectionDialog: React.FC<RemoveSectionDialogProps> = ({ open, sectionTitle, onConfirm, onClose }) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth="sm"
    fullWidth
    data-testid="settings-venue-rules-sections-delete-dialog"
  >
    <DialogTitle>{i18n.t("app.settings.venues.reservation_rules.sections.delete_section_title")}</DialogTitle>
    <DialogContent>
      <div className={STYLES.confirmText}>
        {i18n.t("app.settings.venues.reservation_rules.sections.delete_section_confirm", {
          title: sectionTitle,
        })}
      </div>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} color="inherit" data-testid="settings-venue-rules-sections-delete-dialog-btn-cancel">
        {i18n.t("app.settings.venues.reservation_rules.sections.cancel")}
      </Button>
      <Button
        onClick={onConfirm}
        color="error"
        variant="contained"
        data-testid="settings-venue-rules-sections-delete-dialog-btn-confirm"
      >
        {i18n.t("app.settings.venues.reservation_rules.sections.delete")}
      </Button>
    </DialogActions>
  </Dialog>
)
